import { Component } from '@angular/core';

@Component({
  selector: 'app-codemath24',
  templateUrl: './codemath24.component.html',
  styleUrl: '../../../../../../../../styles-tabelle-orari.css'
})

export class Codemath24Component {

}
